import * as React from 'react';
/**
 * @ignore - internal component.
 */

var Tablelvl2Context = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

export default Tablelvl2Context;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Table/Tablelvl2Context.js
// module id = 80
// module chunks = 0